// Danh mục "Quản lý các Boss" (chỉ Super): hai trang tách ra từ Cài đặt — Mô hình AI dùng chung và Cảnh báo người làm kém.
// Các mục còn lại của danh mục (So sánh Boss, Tài khoản, Soạn thông báo, Nhật ký hệ thống) đã là trang riêng từ trước, chỉ đổi chỗ ở menu.
import { h } from "../dom";
import { isSuper } from "../store";
import { renderModelCard, renderWarnCard } from "./settings";
import { noPermission } from "./users";

export function renderModelPage(root: HTMLElement): () => void {
  if (!isSuper()) return noPermission(root, "Mô hình AI");
  root.append(h("h1", {}, "Mô hình AI (DeepSeek)"),
    h("p", { class: "small muted" }, "Khoá và phiên bản mô hình dùng chung cho MỌI bot của mọi Boss (bot không giữ khoá, gọi qua máy chủ Boss). Boss thường chỉ thấy mô hình đang dùng ở trang Cài đặt của họ."));
  renderModelCard(root);
  return () => {};
}

export function renderWarnPage(root: HTMLElement): () => void {
  if (!isSuper()) return noPermission(root, "Cảnh báo người làm kém");
  root.append(h("h1", {}, "Cảnh báo người làm kém"));
  renderWarnCard(root);
  return () => {};
}
